import Site from "../../interfaces/Site";
import { CREATE_EQUIPMENT_REQUEST_SUCCESS, GET_EQUIPMENT_REQUEST_SUCCESS } from "./actions";
import { Equipment } from "src/interfaces/Equipment";

export default (state : Equipment[] = [], action) => {
    switch (action.type){
        case GET_EQUIPMENT_REQUEST_SUCCESS:
            return [...action.payload];
        case CREATE_EQUIPMENT_REQUEST_SUCCESS: 
            return [...state, action.payload];
        default:
            return state;
    }
}